import { useAccount } from "wagmi";
import type { ReactNode } from "react";
import ConnectModal from "../components/wallet/ConnectModal.tsx";

const ConnectGuard = ({ children }: { children: ReactNode }) => {
  const { isConnected } = useAccount();

  if (isConnected) {
    return <>{children}</>;
  }

  return (
    <>
      <ConnectModal />
    </>
  );
};

export default ConnectGuard;
